<template>
	<div class="mobileLgWrap_he">
		
        <van-nav-bar class="userNavBar" @click-left="onClickLeft" title="修改密码" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<div class="loginMain_he">
			<form>
				<van-cell-group>
					<van-field v-model="mobile" placeholder="请输入手机号" type="text" name="mobile" clearable label-align="left" @input="changColor" />
					<div class="bd_he">
						<van-field v-model="yzm" placeholder="请输入短信验证码" type="text" name="yzm" clearable label-align="left">
							<van-button slot="button" size="small" plain type="info" @click="sendMessage" :disabled="sendCodeBtnDisabled">{{
								sendCodeCaption
							}}</van-button>
						</van-field>
					</div>
					<div :class="phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'" @click="findPassword()">
						<span><a href="javascript:;">下一步</a></span>
					</div>
				</van-cell-group>
			</form>
		</div>
	</div>
</template>

<script>
import md5 from "js-md5";
import { Toast } from 'vant';
export default {
	data() {
		return {
			mobile: "",
			password: "",
			repeatpassword: "",
			yzm: "",
			seen: "",
			seenAgain: "",
			pwdType: "password", // 密码类型
			rightIcon: "closed-eye",
			rightIconAgain: "closed-eye",
			loadingFlg: false,
			loginDisable: false,
			type: "findPassword",
			// 计时器,注意需要进行销毁
			sendCodeBtnDisabled: false,
			sendCodeCaption: "获取验证码",
			refreshTimer: null,
			phoneNum: "",
		};
	},
	methods: {
		changColor(e) {
			this.phoneNum = e.length;
		},
		/**
		 *  判断手机号是否已经存在
		 **/
		//  GET /user/isExistMobile
		isExistMobile() {
			let param = {};
			param.type = this.type;
			param.mobile = this.mobile;
			this.$api.get("/user/isExistMobile", param, (res) => {
				if (res.status == 1) {
					Toast(res.message);
					return false;
				} else {
					let param = {};
					param.type = this.type;
					param.mobile = this.mobile;
					this.$api.get("/user/sendyanzheng", param, (res) => {
						if (res.status == 0) {
							Toast("已发送到您的手机");
							this.countDown();
						} else {
							Toast(res.message);
						}
					});
				}
			});
		},
		// 发送验证码
		sendMessage() {
			// 先判断手机号是否为空 为空输入手机号
			if (this.mobile == "") {
				Toast("请输入手机号");
				return false;
			} else if (!this.$util.isPhoneNumber(this.mobile)) {
				Toast("请输入正确的手机号");
				return false;
			}
			this.isExistMobile();
		},
		// 检查验证码是否正确
		yzmRight() {
			if (this.yzm == "") {
				return false;
			}
			let param = {};
			param.type = this.type;
			param.code = this.yzm;
			// this.$api.get("/user/validCode", param, res => {
			//   Toast(res.message);
			// });
			this.$axiosPackag.getMessageByAxios(
				"GET",
				"/user/validCode",
				param,
				null,
				null,
				(resD) => {
					this.$router.push({ path: "/mobileForgetPasswordNext" });
				},
				(errorCall) => {
                    return false
                }
			);
		},
		countDown() {
			var i = 60;
			this.sendCodeBtnDisabled = true;
			this.refreshTimer = setInterval(() => {
				this.sendCodeCaption = i + "秒后可重新发送";
				i = i - 1;
				if (i == 0) {
					this.clearCountDown();
				}
			}, 1000);
		},
		clearCountDown() {
			this.sendCodeBtnDisabled = false;
			this.sendCodeCaption = "获取验证码";
			clearInterval(this.refreshTimer);
		},
		/**
		 * 忘记密码验证
		 */
		findPassword() {
			if (this.mobile == "") {
				Toast("请输入手机号");
				return false;
			}
			if (!this.$util.isPhoneNumber(this.mobile)) {
				Toast("请输入正确的手机号");
				return false;
			}
			this.yzmRight();
			
		},
        onClickLeft() {
			this.$router.go(-1);
		},
	},
};
</script>
<style >
.userNavBar .van-nav-bar__title {
    font-weight: 600;
}
</style>
<style scoped>
.userNavBar {
	width: 100%;
	margin-top: 0.133333rem;
}
.mobileLgWrap_he{
    background: none;
}
.van-cell,
.van-cell-group {
	background: none;
}
.van-cell {
	background: none;
}
.van-icon-eye-o::before {
	color: #6d7174;
}
.van-cell::after {
	border: none;
}
.van-cell {
	border-bottom: 1px solid #DFDEDE;
    margin-bottom: .72rem;
}
[class*="van-hairline"]::after {
	border: none;
}
/* .van-icon-eye-o::before {
} */
.budgeMobileInput {
	width: 6.933333rem;
}
.senMsg {
	display: inline-block;
	padding: 5px 10px;
	margin: 5px 0;
	color: #ffffff;
	border-radius: 8px;
	font-size: 12px;
	position: absolute;
	right: 0.32rem;
	top: 0.08rem;
}
.bd_he {
	position: relative;
}
.budgeMobileDia {
	width: 5.093333rem;
}
.van-field {
	padding:.213333rem 0  .213333rem 0;
}
.van-button{
    border: none;
}
.van-button--small{
    padding: 0;
}

</style>


// WEBPACK FOOTER //
// MobileForgetPassword.vue?161a03fe